<template lang="pug">
div
  iframe(name='iframe_q' style='display:none;')
  v-form(ref='q_form' target='iframe_q' method='post' action='/udpes/api/dummy' @submit.prevent='route_q')
    v-text-field.ma-1(clearable outlined rounded dense :hint='hint' name='udpes-q' v-model='q_')
      //
        append-icon="mdi-magnify"
        @click:append="route_q"
      template(slot='append')
        v-icon(@click='route_q') mdi-magnify
        v-tooltip(v-model='show_advtip' bottom)
          template(v-slot:activator='{ on, attrs }')
            v-icon(v-bind='attrs' v-on='on' @click='advq_dlg') mdi-magnify-plus
          span {{$t("advsearch")}}
  v-expand-transition
    v-container(v-show='show_adv')
      v-row
        v-col
          v-expansion-panels(v-model='expand_includes')
            v-expansion-panel
              v-expansion-panel-header
                span(v-if='1') {{$t("s.includes")}}
                v-subheader(v-else) {{$t("s.includes")}}
              v-expansion-panel-content
                v-text-field(clearable :label="$t('s.must')" v-model='must_')
                v-text-field(clearable :label="$t('s.should')" v-model='should_')
                v-text-field(clearable :label="$t('s.must_not')" v-model='must_not_')
      v-row
        v-col(v-if='adv_setsn_support')
          v-card
            v-container
              v-row
                v-col
                  v-subheader {{$t("choose_datasets")}}
                  v-treeview(selectable hoverable :items='vault_tree' :open="['_1', '_2', '_3']" v-model='selected_mainsets')
        v-col
          v-card
            v-container
              v-row
                v-col
                  v-subheader {{$t("choose_fields")}}
                  v-treeview(selectable hoverable :items='field_tree' :open="['_']" v-model='selected_fields')
              v-row
                v-col
                  v-subheader {{$t("s.layout")}}
                  v-btn-toggle(v-model='layout_')
                    v-btn(value='def') {{$t("s.default")}}
                    v-btn(value='list') {{$t("s.list")}}
                    v-btn(value='masonry') {{$t("s.block")}}
        v-col
          v-row
            v-card
              v-container
                v-row
                  v-col
                    v-row
                      v-col
                        v-subheader {{$t("pubtime")}}
                    v-row
                      v-col(:cols='7')
                        v-select(:label="$t('s.from_year')" :items='pubyears' v-model='fromYear_' outlined clearable dense :menu-props='{auto:true}')
                      v-col
                        v-select(:label="$t('s.month')" :items='months' :disabled='!fromYear_' v-model='fromMonth_' outlined clearable dense)
                    v-row
                      v-col(:cols='7')
                        v-select(:label="$t('s.until_year')" :items='pubyears' v-model='toYear_' outlined clearable dense :menu-props='{auto:true}')
                      v-col
                        v-select(:label="$t('s.month')" :items='months' :disabled='!toYear_' v-model='toMonth_' outlined clearable dense)
                v-row
                  v-col
                    v-subheader {{$t("s.sort")}}
                    v-btn-toggle(v-model='sort_' mandatory)
                      v-btn(value='relevant') {{$t("s.relevant")}}
                      v-btn(value='pubtime') {{$t("s.pubtime")}}
                      v-btn(value='pubtime_asc') {{$t("s.pubtime_asc")}}
                v-row
                  v-col
                    v-subheader {{$t("s.results_per_page")}}
                    v-btn-toggle(v-model='batch_' mandatory)
                      v-btn(:value='20') 20
                      v-btn(:value='50') 50
                      v-btn(:value='100') 100
          v-row(justify="end")
            v-btn.ma-3(@click="route_q") {{$t("advsearch")}}
              v-icon mdi-magnify
            v-btn.ma-3(@click="reset_options") {{$t("s.reset")}}
              v-icon mdi-undo
</template>
<script>
import VueRouter from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = VueRouter
import { default_search_setsn, mainsets } from "@/api";
import { find_mainset, mainset_name } from "@/api/util";
import { debug } from "@/api/logging";
import router from "@/router";
import VTipIconBtn from "@/components/VTipIconBtn";
import _ from "lodash";
import { ignoreNextOnError } from '@sentry/browser/dist/helpers';
import { ref, computed, toRefs } from '@vue/composition-api'
import store from '@/store'

function default_fields_(uniname, mainset_id) {
  let setsn
  if(mainset_id !== undefined) {
    setsn = mainset_id
  }
  else if(uniname !== undefined) {
    const rr = find_mainset(uniname)
    setsn = rr.mainset_id ? rr.mainset_id : rr.id
  }
  else {
    setsn = undefined
  }
  let fields
  if(['soc', 'sin'].includes(setsn)) {
    fields = ["title", "title2", "authors", "keyword", "content"]
  }
  else if(['tcm', 'bio', 'mdn'].includes(setsn)) {
    fields = ["title", "authors", "content"]
  }
  else if(['cbs', 'tai', 'syu'].includes(setsn)) {
    fields = ["title", "authors", "content"]
  }
  else if(['npm', 'art'].includes(setsn)) {
    fields = ["title", "authors", "content", "imagedes"]
  }
  else if(setsn == 'waa') {
    fields = ["title", "authors", "content", "word", "sourcesdes", "dynasty"]
  }
  else {
    fields = ["title", "authors", "keyword", "content"]
  }
  return fields
}

export default {
  name: "SearchBar",
  watch: {
    scope_changed: {
      handler() {
        if(this.$store.state.show_advsearch_tip_count == 0) {
          this.flash_advtip()
          this.$store.commit('show_advsearch_tip')
        }
      },
      immediate: true,
    },
  },
  methods: {
    flash_advtip() {
      window.setTimeout(()=>{
        this.show_advtip = true
        window.setTimeout(()=>{
          this.show_advtip = false
        }, 60000)
      }, 1000)
    },
    advq_dlg() {
      this.show_adv = !this.show_adv;
    },
    route_q() {
      if(this.must_ !== "" || this.should_ !== "" || this.must_not_ !== "") {
        const q = []
        this.must_.split(' ').forEach((s)=> {
          if(s !== "") q.push("+" + s)
        })
        this.should_.split(' ').forEach((s)=> {
          if(s !== "") q.push(s)
        })
        this.must_not_.split(' ').forEach((s)=> {
          if(s !== "") q.push("-" + s)
        })
        this.q_ = q.join(" ")
      }
      const q = this.q_;
      const uniname = this.uniname;
      const mainset_id = this.mainset_id;
      debug("route_q", q, batch, uniname, mainset_id);
      debug(Boolean(this.$refs.q_form && this.$refs.q_form.$el));
      if (this.q_ && this.$refs.q_form && this.$refs.q_form.$el) {
        this.$refs.q_form.$el.submit();
      }

      const batch = this.batch_ == 20 ? undefined : this.batch_;
      const layout = this.layout_ == "def" ? undefined : this.layout_;
      const fromYear = this.fromYear_;
      const toYear = this.toYear_;
      const fromMonth = this.fromMonth_;
      const toMonth = this.toMonth_;
      const sort = this.sort_;
      const setsn_ = Object.assign([], this.selected_mainsets).sort();
      const setsn = _.isEqual(setsn_, default_search_setsn.sort())
        ? undefined
        : setsn_.join(",");
      const fields_ = Object.assign([], this.selected_fields).sort();
      const fields = _.isEqual(fields_, default_fields_(this.uniname, this.mainset_id).sort())
        ? undefined
        : fields_.join(",");
      debug('fields_', fields, fields_)
      // const fields = fields_.join(",");
      const query = { batch, layout, fromYear, fromMonth, toYear, toMonth, fields, sort }
      for (let k in query) {
        if (!query[k]) delete query[k];
      }
      debug("qq", query);
      // this.show_adv = false
      function get_d() {
        if (uniname) {
          return {
            name: "JournalSearch",
            params: {uniname, q},
            query,
          }
        } else if (mainset_id) {
          return {
            name: "CollectionSearch",
            params: {mainset_id, q},
            query,
          }
        } else {
          const d = {
            name: "VaultsSearch",
            params: {q},
            query: Object.assign({}, query, {setsn}),
          }
          for (let k in d.query) {
            if (d.query[k] === undefined) delete d.query[k];
          }
          return d
        }
      }
      const d = get_d()
      this.show_adv = false
      // this.expand_includes  // undefined
      this.must_ = ""
      this.must_not_ = ""
      this.should_ = ""
      router.push(d).catch(failure => {
        if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
          this.$emit('on-resend')
        }
        else {
          throw failure
        }
      })
    },
  },
  computed: {
    vault_tree() {
      let vault_tree = [];
      for (let i = 0; i < mainsets.length; i++) {
        const id = mainsets[i]
        if(id == 'group') {
          continue
        }
        if(id == 'waa') {
          const waa = {
            id: "waa",
            name: this.$t('toc.waa'),
            children: [
              {
                id: "wai",
                name: this.$t('toc.wai'),
              },
              {
                id: "diw",
                name: this.$t('toc.diw'),
              },
            ],
          }
          vault_tree.push(waa);
        }
        else {
          const d = {
            id,
            name: this.$t('toc.'+id),
          }
          vault_tree.push(d);
        }
      }
      vault_tree = [
        {
          id: '_3',
          name: this.$t('toc.arts'),
          children: vault_tree.filter((e)=>['npm', 'art', 'waa'].includes(e.id))
        },
        {
          id: '_1',
          name: this.$t('toc.journal'),
          children: vault_tree.filter((e)=>['tdm', 'tcm', 'soc', 'sin', 'bio', 'mdn'].includes(e.id))
        },
        {
          id: '_2',
          name: this.$t('toc.book'),
          children: vault_tree.filter((e)=>['cbs', 'tai', 'syu'].includes(e.id))
        },
      ]
      return vault_tree
    },
    field_tree() {
      const fields = default_fields_(this.uniname, this.mainset_id)
      let field_tree = []
      for(let i = 0; i < fields.length; i++) {
        const id = fields[i]
        const name = this.$t(id)
        field_tree.push({id, name})
      }
      field_tree = [
        {id: "_", name: this.$t("fields"), children: field_tree}
      ]
      return field_tree
    },
    scope_changed() {
      return this.uniname + this.mainset_id
    },
    adv_setsn_support() {
      return !this.mainset_id && !this.uniname;
    },
    hint() {
      if (this.uniname) {
        return this.$t("search_this_journal", {j: this.$t('journal')})
      } else if (this.mainset_id) {
        return this.$t("search_this_vault")
      } else {
        return this.$t("search_all_vaults")
      }
    },
  },
  setup(props) {
    function num(v) {
      const vv = Number(v);
      if (Number.isNaN(vv)) return undefined;
      else return vv;
    }

    // ANCHOR 從props帶進來的進階搜尋設定
    const {q, setsn, fields, fromYear, fromMonth, toYear, toMonth, layout, batch, sort} = props
    const q_ = ref(q)
    const selected_mainsets = ref(setsn)
    const selected_fields = ref(fields)
    const fromYear_ = ref(num(fromYear))
    const fromMonth_ = ref(num(fromMonth))
    const toYear_ = ref(num(toYear))
    const toMonth_ = ref(num(toMonth))
    const layout_ = ref(layout) // list, masonry, undefined
    const batch_ = ref(batch)
    const must_ = ref("")
    const must_not_ = ref("")
    const should_ = ref("")
    const sort_ = ref(sort)
    const reset_options = function() {
      q_.value = q
      selected_mainsets.value = setsn
      selected_fields.value = fields
      fromYear_.value = num(fromYear)
      fromMonth_.value = num(fromMonth)
      toYear_.value = num(toYear)
      toMonth_.value = num(toMonth)
      layout_.value = layout // list, masonry, undefined
      batch_.value = batch
      must_.value = ""
      must_not_.value = ""
      should_.value = ""
      sort_.value = "relevant"
    }

    return {
      reset_options,
      q_, selected_mainsets, selected_fields, fromYear_, fromMonth_, toYear_, toMonth_, layout_, batch_,
      must_, must_not_, should_, sort_,
      expand_includes: ref(0),
      show_advtip: ref(),
      show_adv: ref(false),
      pubyears: ref(store.state.pubyears),
      months: ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 12]),
    }
  },
  props: {
    q: {},
    uniname: {},
    mainset_id: {},
    batch: {
      type: Number,
      default: 20,
    },
    layout: {
      type: String,
      default: "def", // list, masonry, undefined
    },
    fromYear: {},
    fromMonth: {},
    toYear: {},
    toMonth: {},
    setsn: {
      type: Array,
      default() {
        return default_search_setsn
      },
    },
    sort: {},
    fields: {
      type: Array,
      default() {
        return default_fields_(this.uniname, this.mainset_id)
      },
    },
  },
  components: {
    VTipIconBtn,
  },
};
</script>
